import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const ClearCalendarFeedTokenMutation = graphql(`
  mutation ClearCalendarFeedToken {
    clearCalendarFeedToken
  }
`);

export const useClearCalendarFeedToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => gqlClient.request(ClearCalendarFeedTokenMutation),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.calendarFeed() });
    },
  });
};

export default useClearCalendarFeedToken;
